// src/components/SessionExpired.jsx
import React from "react";
import { useNavigate } from "react-router-dom";
import { supabase } from "services/supabaseClient";
import {
  clearActivityState,
  clearSessionLogoutFlags,
} from "lib/sessionActivity";

/**
 * Simple full-screen message shown when a user is signed out automatically
 * after inactivity. Local DebtStudio session data is preserved so the user
 * can log back in and restore their draft.
 */
export default function SessionExpired() {
  const navigate = useNavigate();

  const handleLogBackIn = async () => {
    clearActivityState();
    clearSessionLogoutFlags();

    try {
      await supabase.auth.signOut();
    } catch {
      // ignore sign-out failures
    }

    clearSessionLogoutFlags();
    navigate("/start", { replace: true });
  };

  return (
    <div className="flex flex-col items-center justify-center h-screen bg-surface text-app p-6">
      <div className="bg-white dark:bg-gray-900 rounded-2xl shadow-lg p-8 max-w-md w-full text-center">
        <h1 className="text-2xl font-semibold mb-3 text-brand">
          Session Expired
        </h1>
        <p className="text-muted mb-6 leading-relaxed">
          You were signed out due to inactivity. Any recent work has been saved
          locally and can be restored after you log back in.
        </p>
        <button
          type="button"
          onClick={handleLogBackIn}
          className="btn btn-primary w-full sm:w-auto inline-block"
        >
          Log Back In
        </button>
      </div>
    </div>
  );
}
